import type { SVGProps } from 'react'
import { cn } from '@/lib/cn'

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg'

const SIZE_CLASS: Record<SpinnerSize, string> = {
  xs: 'size-3',
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-7',
}

export interface SpinnerProps extends Omit<SVGProps<SVGSVGElement>, 'size'> {
  size?: SpinnerSize
}

/**
 * Indicador de carregamento puramente decorativo: quem o usa precisa
 * comunicar o estado por texto (`aria-busy`, `aria-live` ou label visível).
 */
export function Spinner({ size = 'sm', className, ...props }: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={cn('shrink-0 animate-spin', SIZE_CLASS[size], className)}
      {...props}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" className="opacity-25" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
